const blog_posts_carousel = () => {
    $('.blog_posts--carousel_slider').on('init', function(event, slick){
        // Start at 10%
        $('.blog_posts--carousel--mobile_navigation_blue').css('width', '10%');
    });
    $('.blog_posts--carousel_slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
        const totalSlides = slick.slideCount;
        const slidesToShow = slick.options.slidesToShow;
        const maxIndex = totalSlides - slidesToShow;
        let percent = 10; // initial 10%
        if (maxIndex > 0) {
            const progress = nextSlide / maxIndex;
            percent += progress * 90; // fill remaining 90%
        } else {
            percent = 100;
        }
        $('.blog_posts--carousel--mobile_navigation_blue').css('width', percent + '%');
    });
    $('.blog_posts--carousel_slider').slick({
        dots: false,
        infinite: true,
        slidesToShow: 3,
        nextArrow: '.blog_posts--carousel--navigation_next',
        prevArrow: '.blog_posts--carousel--navigation_prev',
        responsive: [
            {
              breakpoint: 991,
              settings: {
                slidesToShow: 2,
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
              }
            }
        ]
    });
};

export default blog_posts_carousel;